var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{attrs:{"type":_vm.type,"transition":_vm.transition}})}
var staticRenderFns = []

export { render, staticRenderFns }